
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 44 44","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('circle',{attrs:{"fill":"var(--status-svg-color)","cx":"22","cy":"22","r":"22"}}),_c('path',{attrs:{"d":"M11 11h22v22H11z"}}),_c('path',{attrs:{"d":"M26.5 13.8h3.6a.9.9 0 01.9.9v14.4a.9.9 0 01-.9.9H13.9a.9.9 0 01-.9-.9V14.7a.9.9 0 01.9-.9h3.6V12h1.8v1.8h5.4V12h1.8v1.8zm2.7 7.2H14.8v7.2h14.4V21zm-4.5-5.4h-5.4v1.8h-1.8v-1.8h-2.7v3.6h14.4v-3.6h-2.7v1.8h-1.8v-1.8zm-8.1 7.2h1.8v1.8h-1.8v-1.8zm4.5 0h1.8v1.8h-1.8v-1.8zm4.5 0h1.8v1.8h-1.8v-1.8z","fill":"#FFF","fill-rule":"nonzero"}})])])
          )
        }
      }
    